import {Component} from '@angular/core';
import {UnitIcon} from '../../../dashboard/monitoring/unit-icon';

@Component({
  selector: 'app-charge-status-render',
  templateUrl: './charge-status-render.component.html',
})
export class ChargeStatusRenderComponent {

  public params: any;

  constructor() {
  }

  getChargeIconClass(): string {
    if (!this.params || !this.params.data || !this.params.data[this.params.paramsStatusName]) {
      return 'icon';
    }
    return UnitIcon.unitChargeStatusIconClass(this.params.data[this.params.paramsStatusName]);
  }

  agInit(params: any): void {
    this.params = params;
  }
}
